export function getFilterStateName(feature) {
    return feature ? `${feature}FilterState` : null;
}

export function getFilterState(feature) {
    switch (feature) {
        case 'Due-dates':
            return getFilterStateName("overview");
        case 'Todo':
            return getFilterStateName("overview");
        case 'Overview':
            return getFilterStateName("overview");
        //return getFilterStateName("toDo");
        //return getFilterStateName("dueDate");
        case 'Calendar':
            return getFilterStateName("calendar");
        default:
            return null;
    }
}
